<template>
  <BaseDialog :is-open="isOpen" @close="emit('close')">
    <form
      novalidate
      class="flex flex-col gap-4 px-2 py-4"
      @submit="onFormSubmit"
    >
      <FormInputText name="email" label="Email Address" />
      <FormSubmitButton :is-submitting="isSubmitting"
        >Send Receipt</FormSubmitButton
      >
    </form>
  </BaseDialog>
</template>

<script setup lang="ts">
import z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import { emailAddressSchema } from "@/validation/sharedStringFieldSchemas"

const props = defineProps<{
  isOpen: boolean
  orderId?: string
  donationId?: string
  transactionId?: string
}>()

const emit = defineEmits<{
  (event: "close"): void
}>()

const formSchema = z.object({
  email: emailAddressSchema(
    "Please enter a valid email address"
  ),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: { email: "" },
})

const onFormSubmit = handleSubmit(async (formValues) => {
  try {
    if (props.orderId) {
      await sendOrderReceipt(props.orderId, formValues)
    } else if (props.donationId) {
      await sendDonationReceipt(
        props.donationId,
        formValues
      )
    } else if (props.transactionId) {
      await sendTransactionReceipt(
        props.transactionId,
        formValues
      )
    }

    toast.success(`Receipt sent to ${formValues.email}`)
    emit("close")
  } catch {
    toast.error("Failed to send receipt")
  }
})
</script>
